function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconGeldZurck = function SvgIconGeldZurck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 112.51 112.51",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(-903.89 -483.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M963.75,483.12h52.65a0,0,0,0,1,0,0v58.51a54,54,0,0,1-54,54h-5.86A52.65,52.65,0,0,1,903.89,543v0a59.86,59.86,0,0,1,59.86-59.86Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.86,0h52.65a0,0,0,0,1,0,0V58.51a54,54,0,0,1-54,54H52.65A52.65,52.65,0,0,1,0,59.86v0A59.86,59.86,0,0,1,59.86,0Z",
    style: {
      fill: "#dfeafc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.05,514.77a17.93,17.93,0,1,1-18.39,17.92,18.17,18.17,0,0,1,18.39-17.92Z",
    transform: "translate(-903.89 -483.12)",
    style: {
      fill: "#fec543",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.73,524.92a5.36,5.36,0,0,0-5,2.67,5.55,5.55,0,0,0-.81,2.12h8.37l-.33,1.64h-8.23c0,.17,0,.34,0,.49,0,.63,0,1,0,1.13h7.9l-.35,1.64H951a5.5,5.5,0,0,0,2.47,4,5.79,5.79,0,0,0,3.06.85,5,5,0,0,0,3.58-1.2v2.52a7.86,7.86,0,0,1-3.39.71q-5.54,0-7.49-4.61a12,12,0,0,1-.67-2.26H946.7L947,533h1.29c0-.34,0-.72,0-1.12,0-.16,0-.33,0-.5H946.7l.34-1.64h1.42a7.79,7.79,0,0,1,4-5.74,8.91,8.91,0,0,1,4.35-1.08,7,7,0,0,1,3.84,1l-.49,2.28a5.22,5.22,0,0,0-3.4-1.24Z",
    transform: "translate(-903.89 -483.12)",
    style: {
      fill: "#2c2b2c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.35 85.24 4.68 105.61 8.65 102.4 12.7 100.86 17.99 100.53 28.68 103.68 51.12 110.68 62.38 102.98 89.98 82.13 90.2 78.4 87.71 76.17 84.62 76.78 81.44 78.1 79 77.39 76.3 75.31 62.98 80.51 55.63 79.94 27.54 76.75 17.94 79.63 4.35 85.24 4.35 85.24",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.21,594.65a7.79,7.79,0,0,1-2.44-.39l-27.28-9a14.89,14.89,0,0,0-11.67,1.06l-3.8,3.31a1.26,1.26,0,0,1-.83.31,1.27,1.27,0,0,1-1.26-1.27V567.77a1.25,1.25,0,0,1,.83-1.18l16.57-6.11a23,23,0,0,1,10.44-1.24l30.76,3.53a5.46,5.46,0,0,1,4.82,5.4c0,.16,0,.32,0,.49a5.25,5.25,0,0,1-.25,1.19l16.68-11a5.82,5.82,0,0,1,7.27.88,5.67,5.67,0,0,1-.82,8.47L958.8,593.16a7.79,7.79,0,0,1-4.59,1.49ZM919.92,582a16.84,16.84,0,0,1,5.36.85l27.28,9a5.26,5.26,0,0,0,4.75-.74l34.42-24.93a3.13,3.13,0,0,0,1.28-2.24,3.18,3.18,0,0,0-.83-2.46,3.22,3.22,0,0,0-4-.48l-28.87,19a1.26,1.26,0,0,1-1.36,0l-9.75-6-7.84.17a1.3,1.3,0,0,1-1.29-1.24v0a1.27,1.27,0,0,1,1.24-1.27l8.2-.18h0l16.48-.36a2.93,2.93,0,0,0,2.83-2.66,1.93,1.93,0,0,0,0-.24,2.91,2.91,0,0,0-2.58-2.88l-30.75-3.53a20.39,20.39,0,0,0-9.29,1.1l-15.74,5.81v17.27l1.8-1.56.22-.16a17.53,17.53,0,0,1,8.44-2.17Zm32.88-8.17,5.75,3.56,5.82-3.82-11.57.26Z",
    transform: "translate(-903.89 -483.12)",
    style: {
      fill: "#383838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.14,565.45h0a1.27,1.27,0,0,1-.48-2.44l11.51-4.77a6.56,6.56,0,0,1,7.6,2l.7.88a1.26,1.26,0,0,1,.27.79,1.26,1.26,0,0,1-2.26.78l-.7-.88a4,4,0,0,0-4.64-1.21l-11.51,4.77a1.38,1.38,0,0,1-.49.1Z",
    transform: "translate(-903.89 -483.12)",
    style: {
      fill: "#383838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955,552.87a20.26,20.26,0,1,1,20.26-20.26A20.36,20.36,0,0,1,955,552.87Zm0-38a17.73,17.73,0,1,0,17.73,17.72A17.81,17.81,0,0,0,955,514.89Z",
    transform: "translate(-903.89 -483.12)",
    style: {
      fill: "#383838"
    }
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconGeldZurck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Geld_Zurück.47fc708d.svg";
export { ForwardRef as ReactComponent };